import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { VoteForm } from '@/components/VoteForm';
import { useLanguage } from '@/contexts/LanguageContext';

interface VoteCaptchaProps {
  children: React.ReactNode;
  serverId: string;
  serverName: string;
  gameType: string;
  defaultPlayerName?: string;
  lockPlayer?: boolean;
}

export const VoteCaptcha: React.FC<VoteCaptchaProps> = ({
  children,
  serverId,
  serverName,
  gameType,
  defaultPlayerName,
  lockPlayer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  const handleDialogTriggerClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen} modal>
      <DialogTrigger asChild>
        <div onClick={handleDialogTriggerClick}>
          {children}
        </div>
      </DialogTrigger>
      <DialogContent 
        className="bg-gray-900 border-gray-700 max-w-md max-h-[90vh] overflow-y-auto w-[95vw] sm:w-full"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-blue-400 font-mono">
            {t('vote.dialogTitle', { serverName })}
          </DialogTitle>
        </DialogHeader>
        
        <VoteForm
          serverId={serverId}
          serverName={serverName}
          gameType={gameType}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          defaultPlayerName={defaultPlayerName}
          lockPlayer={lockPlayer}
        />
      </DialogContent>
    </Dialog>
  );
};